import { FC } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import stickers, { StickerConfig } from 'src/common/components/Sticker/stickerMap';
import StickersHeader from 'src/common/components/StickersHeader';
import SearchHero from 'src/common/components/Search/SearchHero';
import styles from './Hero.module.scss';

const Hero: FC = () => {
  const [t] = useTranslation('parties-page');
  const stickerAction = stickers.find((s) => s.name === 'cupcake') as StickerConfig;
  const stickerThing = stickers.find((s) => s.name === 'party-floaty') as StickerConfig;
  return (
    <PitchPageLayout
      backgroundColor="ivory"
      outerChildren={(
        <div className={styles.searchBar}>
          <SearchHero variant="hero" />
        </div>
      )}
      variant="headerWithSearch"
    >
      <div className={styles.root}>
        <StickersHeader
          i18nKey="hero--title"
          isInteractive={false}
          isStickerPositionBasedOnBreakpoint
          stickerAction={stickerAction}
          stickerThing={stickerThing}
          translationFunction={t}
        />
        <div className={styles.subTitle}>
          <Typography type="h1" size="body-xl">
            <Trans
              t={t}
              i18nKey="hero--subtitle"
              components={{
                breakLarge: (
                  <div className={styles.breakLarge} />
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default Hero;
